import { render } from "./PublicationPage.vue?vue&type=template&id=3de46544&scoped=true"
import script from "./PublicationPage.vue?vue&type=script&lang=js"
export * from "./PublicationPage.vue?vue&type=script&lang=js"

import "./PublicationPage.vue?vue&type=style&index=0&id=3de46544&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de46544"]])

export default __exports__